import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import ControlGroupParticipant from "./controlGroupParticipant";
import ControlGroupSegment from "./controlGroupSegment";
import ControlGroupSurface from "./controlGroupSurface";

export interface ControlGroupItemProps extends React.HTMLAttributes<HTMLDivElement> {
  grow?: boolean;
  invalid?: boolean;
}

const ControlGroupItem = forwardRef<HTMLDivElement, ControlGroupItemProps>(
  ({ children, className, grow, invalid, ...props }, ref) => (
    <ControlGroupParticipant grow={grow}>
      <ControlGroupSurface
        {...props}
        ref={ref}
        data-slot="control-group-item"
        fill
        invalid={invalid}
        className={twMerge(!grow && "w-auto", className)}
      >
        <ControlGroupSegment grow>{children}</ControlGroupSegment>
      </ControlGroupSurface>
    </ControlGroupParticipant>
  ),
);

export default ControlGroupItem;
